<template>
  <div class="min-h-screen h-full bg-white">

    <TsHeader data-testid="header" />

    <div>
      <slot />
    </div>

    <TsFooter data-testid="footer" />

  </div>
</template>
<script setup lang="ts">

const TsFooter = defineAsyncComponent(
    () => import('~/components/TsFooter.vue')
);

const TsHeader = defineAsyncComponent(
    () => import('~/components/TsHeader.vue')
);
</script>